import { render, staticRenderFns } from "./DiagAlisonDesktop.vue?vue&type=template&id=fdda4388&scoped=true"
import script from "./DiagAlisonDesktop.vue?vue&type=script&lang=js"
export * from "./DiagAlisonDesktop.vue?vue&type=script&lang=js"
import style0 from "./DiagAlisonDesktop.vue?vue&type=style&index=0&id=fdda4388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdda4388",
  null
  
)

export default component.exports